import * as React from 'react';
import cx from 'classnames';

import { Clickable } from '../../../../components/Clickable/Clickable';
import { Navigation } from '../../../../components/Navigation/Navigation';
import { navigation } from '../../../../config/routes';
import { SocialsNavigation } from '../SocialsNavigation/SocialsNavigation';

import * as cs from './MainNavigation.module.css';

interface Props {
  className?: string;
}

export const MainNavigation = ({ className, ...props }: Props) => {
  return (
    <>
      <Navigation className={cx(cs.root, className)} label="Main" {...props}>
        {navigation.map((entry) => (
          <Clickable
            className={cs.linkWrapper}
            activeClassName={cs.active}
            key={entry.label}
            to={entry.url}
            partiallyActive
            trackEvent={`primary-navigation-${entry.label
              .toLowerCase()
              .replace(/\s/g, '-')}`}
          >
            <div className={cs.link}>{entry.label}</div>
          </Clickable>
        ))}

        <SocialsNavigation mobileOnly />
      </Navigation>
    </>
  );
};
